import React, { useEffect, useState, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, redirect } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { ReactSession } from 'react-client-session';

import 'rsuite/dist/rsuite.min.css';
import './App.css';

import { DataProvider } from './store/StoreData';

const ProductTimelines24Months = React.lazy(() => import('./views/ProductTimelines24Months'));
const ProductTimelinesByWeek = React.lazy(() => import('./views/ProductTimelinesByWeek'));
const MainReportDump = React.lazy(() => import("./views/MainReportDump"));
const UserLogin = React.lazy(() => import("./views/UserLogin"));
const UserRegister = React.lazy(() => import("./views/UserRegister"));
const MasterScreen = React.lazy(() => import("./views/masterscreen/MasterScreen"));
const ForgotPassword = React.lazy(() => import("./views/ForgotPassword"));
const TeamManagerScreenComponent = React.lazy(() => import("./components/TeamManagerScreenComponet"));
const TimeSheetScreenComponet = React.lazy(() => import("./components/TimeSheetScreenComponet"));
const ChangePassword = React.lazy(() => import("./views/ChangePassword"));
const ForgetPasswordToken = React.lazy(() => import("./views/ForgetPasswordToken"));
const CustomReport = React.lazy(() => import("./components/CustomReport"))

function App() {

	ReactSession.setStoreType("localStorage");

	const [currentUser, setCurrentUser] = useState(ReactSession.get("username"));

	function requestNotificationPermisson() {
		const permission = Notification.requestPermission();
		if (permission === 'granted') {
			// DO NOTHING
		} else if (permission === 'denied') {
			alert("You denied for the permission");
		}
	}

	useEffect(() => {
		/* Storing user's device details in a variable*/
		let details = navigator.userAgent;

		/* Creating a regular expression containing some mobile devices keywords to search it in details string*/
		let regexp = /android|iphone|kindle|ipad/i;

		/* Using test() method to search regexp in details it returns boolean value*/
		let isMobileDevice = regexp.test(details);

		if (isMobileDevice) {
			console.log("You are using a Mobile Device, Service Workers is not supported....");
		} else {
			console.log("Registering Service Worker for Desktop Browser");
			requestNotificationPermisson();
		}

		setCurrentUser(ReactSession.get("username"));
	}, [currentUser]);

	const Loading = () => {
		return (
			<Box width='100vw' height='100vh' display='flex' justifyContent='center' alignItems='center'><CircularProgress /></Box>
		)
	}

	return (
		<>
			<DataProvider>
				<BrowserRouter>
					<Routes>
						<Route exact path='/' element={currentUser ? <Navigate replace to={"/reports/main-report-dump"} /> : <Navigate replace to="/login" />} />
						<Route exact path='/login' element={<Suspense fallback={<Loading />}><UserLogin /></Suspense>} />
						<Route exact path='/register' element={<Suspense fallback={<Loading />}><UserRegister /></Suspense>} />
						<Route exact path='/forgot-password' element={<Suspense fallback={<Loading />}><ForgotPassword /></Suspense>} />
						<Route exact path='/change-password' element={currentUser ? <Suspense fallback={<Loading />}> <ChangePassword /></Suspense> : <Navigate replace to="/login" />} />
						<Route path='/reset-password/:token/:email/:date' element={<Suspense fallback={<Loading />}><ForgetPasswordToken /></Suspense>} />
						<Route exact path='/admin/master-screen' element={currentUser ? <Suspense fallback={<Loading />}> <MasterScreen /></Suspense> : <Navigate replace to="/login" />} />
						<Route exact path='/CustomReport/:id/:reportName' element={currentUser ? <Suspense fallback={<Loading />}> <CustomReport /></Suspense> : <Navigate replace to="/login" />} />
						{/* <Route exact path='/admin/master-screen/major-measures' element={currentUser ? <Suspense fallback={<Loading />}> <MajorMeasures /></Suspense> : <Navigate replace to="/login" />} /> */}
						{/* <Route exact path='/admin/master-screen/major-tasks' element={currentUser ? <Suspense fallback={<Loading />}> <MajorTasks /></Suspense> : <Navigate replace to="/login" />} /> */}
						{/* <Route exact path='/admin/master-screen/teams' element={currentUser ? <Suspense fallback={<Loading />}> <Team /></Suspense> : <Navigate replace to="/login" />} /> */}
						{/* <Route exact path='/admin/master-screen/processes' element={currentUser ? <Suspense fallback={<Loading />}> <Processes /></Suspense> : <Navigate replace to="/login" />} /> */}
						{/* <Route path='/admin/master-screen/roles' element={currentUser ? <Suspense fallback={<Loading/>}>  <Roles /></Suspense>} /> */}
						{/* <Route exact path='/admin/master-screen/team-members' element={currentUser ? <Suspense fallback={<Loading />}> <TeamMember /></Suspense> : <Navigate replace to="/login" />} /> */}
						{/* <Route exact path='/admin/master-screen/tasks' element={currentUser ? <Suspense fallback={<Loading />}> <Task /></Suspense> : <Navigate replace to="/login" />} /> */}
						<Route exact path='/reports/main-report-dump' element={currentUser ? <Suspense fallback={<Loading />}> <MainReportDump /></Suspense> : <Navigate replace to="/login" />} />
						<Route exact path='/reports/team-managers' element={currentUser ? <Suspense fallback={<Loading />}> <TeamManagerScreenComponent /></Suspense> : <Navigate replace to="/login" />} />
						<Route exact path='/reports/timesheet' element={currentUser ? <Suspense fallback={<Loading />}> <TimeSheetScreenComponet /> </Suspense> : <Navigate replace to="/login" />} />
						{/* <Route exact path='/timelines'  element={<ProductTimelinesView />} /> */}
						<Route exact path='/timelines' element={<Navigate replace to="/timelines/24-months" />} />
						{/* <Route exact path='/timelines' element={<Navigate to="/timelines/24-months" />} /> */}
						<Route exact path='/timelines/24-months' element={currentUser ? <Suspense fallback={<Loading />} ><ProductTimelines24Months /></Suspense> : <Navigate replace to="/login" />} />
						<Route exact path='/timelines/weekly' element={currentUser ? <Suspense fallback={<Loading />} ><ProductTimelinesByWeek /></Suspense> : <Navigate replace to="/login" />} />
						<Route exact path="*" element={currentUser ? <Navigate replace to={"/reports/main-report-dump"} /> : <Navigate replace to="/login" />} />
					</Routes>
				</BrowserRouter>
			</DataProvider>
		</>
	);
}

export default App;